type Props = {
  open: boolean;
  message: string;
  onCancel: () => void;
  onConfirm: () => void;
};

export function ConfirmModal({ open, message, onCancel, onConfirm }: Props) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-2xl w-80 text-center animate-pop-in">
        <h3 className="font-bold mb-4 whitespace-pre-wrap">{message}</h3>
        <div className="flex gap-2">
          <button onClick={onCancel} className="flex-1 bg-gray-200 py-2 rounded-lg font-bold">
            取消
          </button>
          <button onClick={onConfirm} className="flex-1 bg-red-500 text-white py-2 rounded-lg font-bold">
            確定
          </button>
        </div>
      </div>
    </div>
  );
}
